<div class="relative">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="size-6 rotate-45"
    [ngClass]="notificationCount > 0 ? 'text-white' : 'text-gray-300'"
  >
    <path
      fill-rule="evenodd"
      d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z"
      clip-rule="evenodd"
    />
  </svg>
  @if (notificationCount > 0) {
    <span
      class="absolute -right-2 bottom-1 flex items-center justify-center bg-red-600/70 border border-red-600 text-heading text-xs font-medium text-white h-4 w-4 rounded-full"
    >
      {{ notificationCount }}
    </span>
  }
</div>
